module.exports = "pegasus_template/assets/themelp1/small/12.png";